<app-add-attachment-modal
  [showAddAttachments]="showAddAttachments"
  [view]="'patientInstructionAttachment'"
  [id]="instructionsID"
  [patientID]="patientIDAsNumber"
  (close)="closeAddAttachments()"
></app-add-attachment-modal>
<app-attachment-view
  [doShowAttachmentView]="doShowAttachmentView"
  [attachment]="selectedAttachment"
  [canDelete]="true"  
  [view]="'patientInstructionAttachment'"
  (close)="closeAttachmentView()"
></app-attachment-view>
<div class="container">
  <h2>Patient Instructions</h2>
  <p class="description">Edit the patient instructions that will be shown to staff members.</p>

  @if (isLoading()) {
    <div class="loading">
      <app-loading-indicator />
    </div>
  } @else {
    <div class="row">
      <div class="col-lg-3 col-md-12 mb-2 d-flex justify-content-start align-items-end">
        <button 
          class="btn btn-secondary float-right"
          style="height: 35px;" 
          (click)="toggleShowAddAttachments()" 
          [disabled]="isSaving()">
          <i class="m-0 p-0 pi pi-paperclip"></i>&nbsp;&nbsp;Add Attachments
        </button>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="att-list-container-reverse">
          @for (att of attachmentList; track att.ID) {
            <div class="att-box" role="button" (click)="openAttachmentView(att)">
              @if(att.IsImage){
                <img class="m-2" [src]="getImageUrl(att)" style="min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px;">
              }
              @else{
                <i class="m-0 p-0 pi pi-file-o" style="font-size: 25px;"></i>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-12">
        <div class="editor-container">
          <div class="editor-content">
            <ckeditor
            id="instructions"
            name="instructions"
            [editor]="Editor"
            [config]="editorConfig"
            [data]="initialInstructions"
            (change)="onInstructionsChange($event)"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>

    <div class="actions mt-3">
      <button 
        class="btn btn-primary save-button" 
        (click)="saveInstructions()" 
        [disabled]="isSaving()">
        {{ isSaving() ? 'Saving...' : 'Save Instructions' }}
      </button>
    </div>
  }
</div>
